import type { PropsWithChildren } from "react";

export function Header({ children }: PropsWithChildren) {
  return (
    <header className="app-header">
      <div className="header-content">{children}</div>
    </header>
  );
}
